import React from 'react'
import Layout from '../../Layout'
import BarestHelpContainer from '../../../../Components/BarestHelp/BarestHelpContainer/BarestHelpContainer'

const BarestHelpList = () => {
  return (
    <Layout><BarestHelpContainer/></Layout>
  )
}

export default BarestHelpList